
import { Shield, Award, CheckCircle } from "lucide-react";

const TrustBadges = () => {
  const certifications = [
    {
      name: "ISO 27001 Certified",
      icon: <Shield className="h-8 w-8 text-primary" />,
      description: "Information Security Management"
    },
    {
      name: "GDPR Compliant",
      icon: <CheckCircle className="h-8 w-8 text-primary" />,
      description: "Data Protection Standards"
    },
    {
      name: "Award Winning",
      icon: <Award className="h-8 w-8 text-primary" />,
      description: "Industry Recognition"
    }
  ];

  const partners = [
    "AWS Partner", "Microsoft Gold Partner", "Google Cloud Partner", 
    "IBM Watson Partner", "Nvidia Developer Partner", "Oracle Partner"
  ];

  return (
    <section className="py-20">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12">
          <div>
            <h2 className="text-2xl font-bold mb-6 gradient-text">Trust & Security</h2>
            <p className="text-gray-400 mb-8">
              We maintain the highest standards of security and compliance to ensure your data and systems are protected.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              {certifications.map((cert, index) => (
                <div key={index} className="flex flex-col items-center p-6 glass-card rounded-lg border border-primary/20 hover:border-primary transition-colors">
                  <div className="mb-4">{cert.icon}</div>
                  <h3 className="font-semibold text-white text-center">{cert.name}</h3>
                  <p className="text-sm text-gray-400 text-center mt-2">{cert.description}</p>
                </div>
              ))}
            </div>

            <div className="mt-8">
              <p className="text-sm text-gray-400">
                All our solutions follow industry best practices for security, performance, and reliability. We regularly undergo security audits and penetration testing to ensure the highest level of protection.
              </p>
            </div>
          </div>

          <div>
            <h2 className="text-2xl font-bold mb-6 gradient-text">Our Partners</h2>
            <p className="text-gray-400 mb-8">
              We collaborate with leading technology providers to deliver cutting-edge solutions.
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
              {partners.map((partner, index) => (
                <div key={index} className="h-20 flex items-center justify-center p-4 glass-card rounded-lg border border-primary/20">
                  <span className="text-gray-300 text-center font-medium">{partner}</span>
                </div>
              ))}
            </div>

            <div className="mt-12">
              <h3 className="text-xl font-semibold mb-4 text-white">As Featured In</h3>
              <div className="grid grid-cols-3 gap-4">
                {["Tech Magazine", "AI Journal", "Business Weekly"].map((publication, index) => (
                  <div key={index} className="h-12 flex items-center justify-center px-4 bg-maitech-800/50 rounded">
                    <span className="text-gray-400 text-sm">{publication}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
